import type { _SVGIcon } from "hsl-core/Components";

const body: _SVGIcon.IconBody = () => {
	return `
    <path d="M0 0.0180664H24V15.9819H0V0.0180664Z" fill="#C8102E"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.78378 6.70267V0.0180664H10.3784V6.70267H24V9.29726H10.3784V15.9819H7.78378V9.29726H0V6.70267H7.78378Z" fill="white"/>
  `;
};

export default {
	W: 24,
	H: 16,
	body,
} as _SVGIcon.Icon;
